import { useState } from 'react';
import STATE from '../../constanta/state';
import CardStart from './components/cardStart';
import CardIntro from './components/cardIntro';
import axios from 'axios';
import CONFIG from '../../constanta/config';
import { useEffect } from 'react';
import LiveGameMatchImage from '../../game/match-image/matchImage.live';
import LiveGameSearchWord from '../../game/search-word/search.live';
import LiveGameHangman from '../../game/hangman/hangman.live';
import LiveGameScrambleWord from '../../game/scramble-word/scrambleWord.live';
import LiveGameMaze from '../../game/maze/maze.live';
import LiveGameCrossWord from '../../game/cross-word/crossWord.live';
import Campaign from '../campaign/campaign';
import Leaderboard from '../leaderboard/leaderboard';
import moment from 'moment';
import GameQuiz from '../../game/quiz/quiz.game';
import { isMobile } from 'react-device-detect';
import RandomScorePopup from '../../game/quiz/RandomScorePopup';
import CardFinish from '../../game/match-image/components/cardFinish';

const Home = () => {
  const [state, setState] = useState(STATE.CAMPAIGN);
  const [user, setUser] = useState(null);
  const [game, setGame] = useState(null);
  const [score, setScore] = useState(0);
  const [gameData, setGameData] = useState(null);
  const [activity, setActivity] = useState({
    id_game: 1
  });
  const [round1, setRound1] = useState([]);
  const [round2, setRound2] = useState([]);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    if (user?.name) {
      getGame();
      //checkScore();
    }
  }, [user]);

  const getConfig = () => {
    setLoading(true);
    axios
      .get(CONFIG.URL + '/config?rnd=' + Date.now(), {})
      .then(function (response) {
        if (response.data.status === 'SUCCESS') {
          setConfig(response.data.config);
        } else {
        }
        setLoading(false);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        setLoading(false);
      });
  };

  const getGame = () => {
    //activity?.id_game
    axios
      .get(CONFIG.URL + '/game/' + activity?.id_game + '?rnd=' + Date.now(), {
        headers: {
          token:
            'eyJpZF9hZG1pbiI6IjEiLCJ0b2tlbiI6ImY1U3FLakdoVDZEeG50YTdFMXNQMSIsInJvbGUiOiJzdXBlcl9hZG1pbiJ9.S8P4yA7hTZ9lpQqOyrTKcl4wdrLq8S_tcUZdLo9pDWY'
        }
      })
      .then(function (response) {
        if (response.data.status === 'SUCCESS') {
          setGame(response.data.data[0]);
        } else {
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
  };

  const handleLogin = (data) => {
    setUser(data);
    checkUser(data);
  };

  const handleBegin = () => {
    setState(STATE.GAME);
  };

  const showGame = () => {
    return (
      <GameQuiz
        user={user}
        game={game}
        activity={activity}
        idActivity={activity?.id}
        score={score}
        gameData={gameData}
        config={config}
      />
    );
  };

  const handleChooseActivity = (val) => {
    setActivity(val);
    setState(STATE.START);
  };

  const checkUser = (data) => {
    setLoading(true);
    axios
      .get(CONFIG.URL + '/leaderboard?name=' + data.name)
      .then(function (response) {
        if (response.data?.data?.length > 0) {
          setGameData(JSON.parse(response.data.data[0].game_data));
          setScore(response.data.data[0].score);

          setState(STATE.FINISH);

          setLoading(false);
        } else {
          setState(STATE.INTRO);
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
  };

  if (activity?.status === 'disable') {
    return (
      <div
        className="App flex justify-center items-center flex-col min-h-screen "
        style={{
          background: `url('${
            isMobile ? config?.background_mobile : config?.background
          }') no-repeat center center fixed`,
          backgroundSize: 'cover'
        }}>
        <div className="relative space-y-5 px-5 py-5 bg-white rounded-md w-full md:w-1/2 z-0">
          <div className="text-center font-bold mb-0 bg-red-500 rounded-md">
            {/* <div className="text-2xl">{focus}</div> */}
            <div className="text-white font-semibold text-xl md:px-10 p-4">
              {
                config.welcome
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {loading ? (
        <div className="font-bold text-center text-white bg-black w-screen h-screen flex justify-center items-center">
          Loading...
        </div>
      ) : (
        <div
          className="App flex justify-start items-start flex-col min-h-screen "
          style={{
            background: `url('${
              isMobile ? config?.background_mobile : config?.background
            }') no-repeat center center fixed`,
            backgroundSize: 'cover'
          }}>
          {/* CAMPAIGN */}
          {state === STATE.CAMPAIGN && (
            <div className="flex justify-center items-center flex-grow w-full p-3">
              <Campaign
                handleChooseActivity={(val) => handleChooseActivity(val)}
                goLead={() => setState(STATE.LEADERBOARD)}
                setRound1={(data) => setRound1(data)}
                setRound2={(data) => setRound2(data)}
                config={config}
              />
            </div>

            // <>
            // <button className="p-4 bg-blue-500 text-white" onClick={() => setShow(!show)}>
            // {show ? 'UNSHOW' : "SHOW"}
            // </button>

            // {show ? <RandomScorePopup onStop={(val) => alert(val)} /> : <></>}
            // </>
          )}
          {/* LEADERBOARD */}
          {state === STATE.LEADERBOARD && (
            <div className="flex justify-start items-start flex-grow w-full p-5">
              <Leaderboard
                leaveLead={() => setState(STATE.CAMPAIGN)}
                actRound1={round1}
                actRound2={round2}
              />
            </div>
          )}
          {/* START */}
          {state === STATE.START && (
            <div className="flex justify-center items-center flex-grow w-full p-3">
              <CardStart
                handleLogin={(val) => handleLogin(val)}
                onBack={() => setState(STATE.CAMPAIGN)}
                config={config}
              />
            </div>
          )}
          {/* INTRO */}
          {state === STATE.INTRO && (
            <div className="flex justify-center items-center flex-grow w-full  p-3">
              <CardIntro
                user={user}
                game={game}
                config={config}
                activity={activity}
                handleBegin={() => handleBegin()}
                score={score}
                onBack={() => setState(STATE.START)}
              />
            </div>
          )}
          {/* INTRO */}
          {state === STATE.FINISH && (
            <div className="flex justify-center items-center flex-grow w-full  p-3">
              <CardFinish
                name={user?.name}
                activity={activity}
                score={score}
                user={user}
                game={game}
                questionDetails={gameData}
              />
            </div>
          )}

          {/* GAME */}
          {state === STATE.GAME && <>{showGame()}</>}
        </div>
      )}
    </>
  );
};

export default Home;
